export function stripHTMLFromText(text) {
  if (!text) return
  return text.replace(/<(?:.|\n)*?>/gm, '')
}



// WEBPACK FOOTER //
// ./node_modules/shared-web/src/helpers/StripHTMLFromText.js